import { useEffect } from "react";
/**
 * Dialog/Sheet uses react-remove-scroll, which preventDefault's wheel events on
 * portaled content (popovers/dropdowns render outside the lock). Native overflow
 * scrolling never runs, so we apply delta to scrollTop ourselves.
 *
 * Capture + non-passive so this wins over parent scroll chaining as well.
 */
export function attachDropdownWheelScroll(element) {
    var onWheel = function (event) {
        var scrollTop = element.scrollTop, scrollHeight = element.scrollHeight, clientHeight = element.clientHeight;
        if (scrollHeight <= clientHeight + 1)
            return;
        var delta = event.deltaMode === 1
            ? event.deltaY * 16
            : event.deltaMode === 2
                ? event.deltaY * clientHeight
                : event.deltaY;
        var maxScroll = scrollHeight - clientHeight;
        var next = Math.max(0, Math.min(maxScroll, scrollTop + delta));
        if (next === scrollTop)
            return;
        event.preventDefault();
        event.stopPropagation();
        element.scrollTop = next;
    };
    element.addEventListener("wheel", onWheel, { passive: false, capture: true });
    return function () { return element.removeEventListener("wheel", onWheel, { capture: true }); };
}
export function useDropdownListScroll(element, enabled) {
    if (enabled === void 0) { enabled = true; }
    useEffect(function () {
        if (!element || !enabled)
            return;
        return attachDropdownWheelScroll(element);
    }, [element, enabled]);
}
